/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';

/**
 * React Component to that manages a group of checkboxes for React Redux fields.
 * Each checkbox its its own field whose name is the field name and value is if its
 * selected or not.
 */
export default class Errors extends React.Component {
  static propTypes = {
    errors: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string
    ]),
    showErrors: PropTypes.bool
  };

  render() {
    const { errors, showErrors } = this.props;
    if (!errors || errors.length < 1 || showErrors === false) return null;

    return (
      <div className="slds-has-error">
        {errors.map((error, index) => {
          return (
            <span key={index} className="slds-form-element__help">
              {error}
            </span>
          );
        })}
      </div>
    );
  }
}
